import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import ConsumerPageWrapper from 'bundles/unified-description-page-common/pages/consumer/ConsumerPageWrapper';

const ConsumerSeriesPageRoot = loadOnRoute(
  () => import('bundles/series-description-page/pages/consumer/ConsumerSeriesPageRoot')
);

export default (
  <Route>
    <CourseraRoute
      path="/"
      component={ConsumerPageWrapper}
      handle={{
        tracking: {
          segment: 'consumer',
        },
      }}
    >
      {/*
       * Consumer-only for now: no locale-subfolder twin (Series has no per-locale URLs) and no
       * enterprise/paid-media/Google variants. UnifiedUserExperienceHandler is deliberately absent
       * — /series is not in UNIFIED_CONSUMER_ROUTES, so it has no org-scoped equivalent to redirect
       * enterprise users to, and the handler would block first render on a membership query for
       * nothing.
       * TODO: set `tracking.data` with `page.type: 'xdp_series'` once that value exists in the
       * PageType union in @coursera/event-pulse-types. `segment: 'consumer'` still inherits from
       * the parent route.
       */}
      <CourseraRoute path="series/:productSlug" getComponent={ConsumerSeriesPageRoot} handle={{ tracking: {} }} />
    </CourseraRoute>
    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </Route>
);
